import BannersHome from './BannersHome';

export default BannersHome;
